// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jG8xw","tabsBox":"styles_tabsBox__26awF","createButton":"styles_createButton__3ql81"};